import user from "@/services/user";

import { decodeToken, deleteToken } from "@/utils";

const initialState = () => ({
  user: {},

  loadingStatus: 1,

  // 1 - Loading, 2 - Successful, 3 - unsuccesful, 4 - uncaught error
  // updating user profile
  updateUserStatus: 0,
  updateUserMessage: null,
  updateUserError: null
});

const state = initialState();

const getters = {
  getDetails: state => state.user,
  getLoadingStatus: state => state.loadingStatus,

  // updating user profile
  updateUserStatus: state => state.updateUserStatus,
  updateUserMessage: state => state.updateUserMessage,
  updateUserError: state => state.updateUserError
};

const actions = {
  getDetails: async ({ commit }) => {
    try {
      const userToken = decodeToken()
      if (userToken) {
        const userId = userToken.id;
        commit("setLoadingStatus", 1);

        const response = await user.getDetails(userId);
        commit("setUser", response.data.data);

        commit("setLoadingStatus", 2);
      }
    } catch (error) {
      commit("setLoadingStatus", 3);
      console.log(error);
    }
  },
  update: async ({ commit }, payload) => {
    try {
      commit("updateUserRequest");
      const userId = decodeToken().id;
      const response = await user.update({ userId, content: payload });
      commit("updateUserSuccess", response.data);
    } catch (error) {
      commit("updateUserError", error);
    }
  },
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },

  setLoadingStatus(state, status) {
    state.loadingStatus = status;
  },

  // updating user profile
  updateUserRequest: state => state.updateUserStatus = 1,
  updateUserSuccess(state, { message, data }) {
    Object.assign(state.user, data);
    state.updateUserStatus = 2;
    state.updateUserMessage = message;
  },
  updateUserError(state, error) {
    state.updateUserStatus = 3;
    state.updateUserMessage = error.response.data.message;
    state.updateUserError = error.response.data.data
  },

  // Reset
  reset(state) {
    deleteToken();
    const originalState = initialState();
    Object.keys(originalState).forEach(key => {
      state[key] = originalState[key];
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
